module.exports = __webpack_public_path__ + "static/img/61.d6f8eba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/61.png
// module id = T4R3
// module chunks = 0